import { put, select, takeLatest } from 'redux-saga/effects';
import { calculateInventory } from '../../lib';
import { getSiteLockers } from '../lockers/selectors';
import { errorReceiveCalculatedInventory, failedReceiveCalculatedInventory, receiveCalculatedInventory } from './slice';
export function* receiveInventory() {
    try {
        const lockers = yield select(getSiteLockers);
        const inventory = calculateInventory(lockers);
        if (!inventory || Object.keys(inventory).length < 1) {
            yield put(errorReceiveCalculatedInventory());
        }
        else {
            yield put(receiveCalculatedInventory(inventory));
        }
    }
    catch (e) {
        yield put(failedReceiveCalculatedInventory());
    }
}
export function* watchReceiveInventory() {
    yield takeLatest('inventory/receiveInventory', receiveInventory);
}
